export default __webpack_public_path__ + "static/media/logoH.74846b6d.png";